import { useState } from 'react';
import { formatValue, formatWhen, yearTable, yearsShown } from './helpers';

/**
 * The values prompts use, one year at a time and grouped by category. Every
 * catalog value is listed, so one the sources haven't supplied can be set by hand.
 */
const ValuesByYear = ({ catalog, rows, currentYear, onEdit }) => {
  const years = yearsShown(rows, currentYear);
  const [year, setYear] = useState(String(currentYear));
  const groups = yearTable(catalog, rows, year);

  return (
    <div className="card">
      <div className="card-header">
        <ul className="nav nav-pills card-header-pills" role="tablist">
          {years.map((y) => (
            <li className="nav-item" key={y}>
              <button
                type="button"
                role="tab"
                aria-selected={y === year}
                className={`nav-link ${y === year ? 'active' : ''}`}
                onClick={() => setYear(y)}
              >
                {y}
              </button>
            </li>
          ))}
        </ul>
      </div>
      <div className="table-responsive">
        <table className="table table-sm mb-0 align-middle">
          <thead>
            <tr>
              <th>Value</th>
              <th className="text-end">In use</th>
              <th>Source</th>
              <th>Approved</th>
              <th>Last confirmed</th>
              <th></th>
            </tr>
          </thead>
          {groups.map((group) => (
            <tbody key={group.key}>
              <tr className="table-light">
                <th colSpan={6}>{group.label}</th>
              </tr>
              {group.entries.map(({ spec, row }) => {
                const hasValue = row && row.value !== undefined && row.value !== null;
                return (
                  <tr key={spec.key}>
                    <td>
                      {spec.label}
                      {row?.proposed && <span className="badge text-bg-warning ms-2">Change waiting</span>}
                      {row?.source_conflict && (
                        <span className="badge text-bg-danger ms-2" title="Another source gives a different figure">
                          Sources disagree
                        </span>
                      )}
                    </td>
                    <td className="text-end fw-semibold">{hasValue ? formatValue(row.value, spec.unit) : '—'}</td>
                    <td className="small">
                      {hasValue && row.source_url ? (
                        <a href={row.source_url} target="_blank" rel="noopener noreferrer">{row.source_ref}</a>
                      ) : (hasValue ? row.source_ref : '')}
                    </td>
                    <td className="small text-muted">
                      {hasValue ? `${row.approved_by || ''} ${formatWhen(row.approved_at)}` : ''}
                    </td>
                    <td className="small text-muted">{hasValue ? formatWhen(row.last_verified_at) : ''}</td>
                    <td className="text-end">
                      <button
                        type="button"
                        className="btn btn-link btn-sm p-0"
                        onClick={() => onEdit(year, spec, row)}
                        aria-label={`${hasValue ? 'Edit' : 'Set'} ${year} ${spec.label}`}
                      >
                        {hasValue ? 'Edit' : 'Set'}
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          ))}
        </table>
      </div>
    </div>
  );
};

export default ValuesByYear;
